import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zk22fce9kn: FaireBrandEntity = {
  token: "b_zk22fce9kn",
  type: "brand",
  name: "Love, Paige Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/584284af741e5582acad8dc8ff446fe081e9d3dd31e5efeff1752bee4dfbe199.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/36f9706c7394e938ce24077d997ced7d0b91e8bd0a6ba74271fbc6ac6606c5fb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/584284af741e5582acad8dc8ff446fe081e9d3dd31e5efeff1752bee4dfbe199.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/36f9706c7394e938ce24077d997ced7d0b91e8bd0a6ba74271fbc6ac6606c5fb.png",
  location: "Granite Falls, NC, USA",
  minimumOrderDollars: 103,
  rating: 5,
  reviewCount: 24,
  isTopShop: true,
  isInsider: true,
  description:
    "Love, Paige Designs was created to help retailers and makers stock charm bars with trend-forward, boutique-ready jewelry supplies that customers genuinely get excited about. What began as a passion for creating and curating meaningful pieces has grown into a wholesale brand designed to support retailers with high-quality charms, chains, connectors, and customizable jewelry components.\n\nBuilt with today’s customer in mind, Love, Paige Designs focuses on offering styles that feel current, versatile, and easy to merchandise — from colorful enamel charms to timeless metals and specialty connectors. Each piece is selected with intention, balancing trend and longevity so retailers can confidently build displays that turn browsers into buyers.\n\nAs a small, independently run business, Love, Paige Designs understands the realities of retail — keeping inventory fresh, staying ahead of trends, and maintaining strong margins. Our goal is to make stocking and restocking simple, dependable, and inspiring. Whether you’re building a full charm bar experience or expanding your jewelry offerings, LPD is here to provide quality components that help your business shine.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:10.430Z",
    importedBy: "entity-db-cli",
  },
};
